import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Skeleton from "@material-ui/lab/Skeleton";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

import Property from "../../../components/core/Property";
import { useUserGroups } from "../../../hooks/data/userGroups";

import useStyles from "./styles";

/**
 * Display the system"s current groups.
 */
export const SystemGroupsPage = () => {
  const classes = useStyles();

  const [groups, , groupsLoading] = useUserGroups();

  const PLACEHOLDER = (
    <Card>
      <CardContent>
        <Typography>
          <Skeleton width="10rem" />
        </Typography>
        <Property className={classes.property} title="CREATED">
          <Skeleton width="10rem" />
        </Property>
      </CardContent>
    </Card>
  );

  return (
    <Container maxWidth="md" className={classes.root}>
      <Typography variant="h5" className={classes.title}>
        <b>Groups</b>
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        The groups configured in MSend. Each group listed here should correspond
        to a single subuser in SendGrid and  a set of groups in Group Admin.
      </Typography>
      <Divider className={classes.divider} />
      <div className={classes.list}>
        {groupsLoading && (
          <>
            {PLACEHOLDER}
            {PLACEHOLDER}
            {PLACEHOLDER}
          </>
        )}
        {Object.entries(groups ?? {}).map(([key, group]) =>
          <Card key={key}>
            <CardContent>
              <div className={classes.cardTitle}>
                <Typography>
                  <b>{group.name}</b>
                </Typography>
                <Typography>
                  <Typography variant="body2" color="textSecondary">
                    {group.id}
                  </Typography>
                </Typography>
              </div>
              <Property className={classes.property} title="CREATED">
                {group.created.toDate().toLocaleDateString()}
              </Property>
              <Property className={classes.property} title="FROM EMAILS">
                <ul className={classes.cardList}>
                  {group.from?.map(email => (
                    <li key={email} className={classes.cardListItem}>{email}</li>
                  ))}
                </ul>
              </Property>
              <Property className={classes.property} title="REPLY-TO EMAILS">
                <ul className={classes.cardList}>
                  {group.replyTo?.map(email => (
                    <li key={email} className={classes.cardListItem}>{email}</li>
                  ))}
                </ul>
              </Property>
            </CardContent>
          </Card>
        )}
      </div>
    </Container>
  );
};
